import {v4 as uuidv4} from 'uuid';

export type PageMetricSessionState = {
  uid: string;
  pageGroup: string;
  startTime: number;
  context: Record<string, unknown>;
  /**
   * Set to true after the first customer_ready fires within this session.
   * Used by useCustomerReadyWhen to decide whether to use session.startTime
   * (initial page load) or Date.now() (subsequent tab switches).
   */
  hasCustomerReadyFired: boolean;
};

let activeSession: PageMetricSessionState | null = null;

type InitPerfMetricSessionOptions = {
  uid?: string;
  startTime?: number;
};

export function initPageMetricSession(
  pageGroup: string,
  context: Record<string, unknown> = {},
  options: InitPerfMetricSessionOptions = {}
): PageMetricSessionState {
  activeSession = {
    uid: options.uid ?? uuidv4(),
    pageGroup,
    startTime: options.startTime ?? Date.now(),
    context,
    hasCustomerReadyFired: false,
  };
  return activeSession;
}

export function endPageMetricSession(uid?: string): void {
  if (!uid || activeSession?.uid === uid) {
    activeSession = null;
  }
}

export function getPerfMetricSession(): PageMetricSessionState | null {
  return activeSession;
}

export function markCustomerReadyFired(): void {
  if (activeSession) {
    activeSession.hasCustomerReadyFired = true;
  }
}

export function getSessionElapsed(): number | null {
  if (!activeSession) {
    return null;
  }
  return Date.now() - activeSession.startTime;
}
